(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.id === 'cart-form' || form.action?.includes('/cart')) {
      const totalText = document.querySelector('[data-cart-subtotal]')?.getAttribute('value') || '';
      const totalNum = parseFloat(totalText.replace(/[^0-9.]/g, ''));
      if (totalNum < 69.90) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pk-photo-viewer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.pkPhotoViewer) return;
    var supported = typeof HTMLDialogElement === 'function' && typeof HTMLDialogElement.prototype.showModal === 'function';

    var dlg, stage, thumbs, titleEl, captionEl, countEl, productBtn, ctaBtn, arrows;
    var data = [], slides = [], thumbBtns = [], current = 0, n = 0;
    var arrowSvg = function (points) {
      return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="' + points + '"/></svg>';
    };

    // The viewer is built once, on first use, and appended to <body> so no
    // section's layout or stacking can clip it.
    function build() {
      dlg = document.createElement('dialog');
      dlg.className = 'pk-pv';
      dlg.innerHTML =
        '<div class="pk-pv__bar"><span class="pk-pv__count" aria-live="polite"></span>' +
        '<button type="button" class="pk-pv__x" aria-label="Close">&times;</button></div>' +
        '<div class="pk-pv__stage">' +
        '<button type="button" class="pk-pv__arrow pk-pv__arrow--prev" data-step="-1" aria-label="Previous photo">' + arrowSvg('15 18 9 12 15 6') + '</button>' +
        '<button type="button" class="pk-pv__arrow pk-pv__arrow--next" data-step="1" aria-label="Next photo">' + arrowSvg('9 18 15 12 9 6') + '</button>' +
        '</div>' +
        '<div class="pk-pv__info"><p class="pk-pv__title"></p><p class="pk-pv__caption"></p>' +
        '<div class="pk-pv__btns"><a class="pk-pv__btn" data-product href="#"></a><a class="pk-pv__btn" data-cta href="#"></a></div></div>' +
        '<div class="pk-pv__thumbs" role="group" aria-label="All photos"></div>';
      document.body.appendChild(dlg);

      stage = dlg.querySelector('.pk-pv__stage');
      thumbs = dlg.querySelector('.pk-pv__thumbs');
      titleEl = dlg.querySelector('.pk-pv__title');
      captionEl = dlg.querySelector('.pk-pv__caption');
      countEl = dlg.querySelector('.pk-pv__count');
      productBtn = dlg.querySelector('[data-product]');
      ctaBtn = dlg.querySelector('[data-cta]');
      arrows = dlg.querySelectorAll('[data-step]');

      dlg.querySelector('.pk-pv__x').addEventListener('click', function () { dlg.close(); });
      arrows.forEach(function (b) {
        b.addEventListener('click', function () { show(current + (+b.dataset.step)); });
      });
      // A click on the dimmed area outside the panel closes the viewer.
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(current + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(current - 1); e.preventDefault(); }
      });

      // Swipe (touch or mouse drag) on the photo area.
      var startX = null, startY = 0;
      stage.addEventListener('pointerdown', function (e) { startX = e.clientX; startY = e.clientY; });
      stage.addEventListener('pointerup', function (e) {
        if (startX === null) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        startX = null;
        if (n > 1 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
      });
      stage.addEventListener('pointercancel', function () { startX = null; });
    }

    function load(i) {
      var img = slides[(i + n) % n].querySelector('img');
      if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
    }

    function show(i) {
      current = (i + n) % n;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === current);
        s.classList.toggle('is-prev', n > 2 && k === (current - 1 + n) % n);
        s.classList.toggle('is-next', n > 1 && k === (current + 1) % n);
      });
      load(current); load(current + 1); load(current - 1);
      var d = data[current];
      titleEl.textContent = d.title || '';
      captionEl.textContent = d.caption || '';
      countEl.textContent = (current + 1) + ' / ' + n;
      productBtn.hidden = !d.url || !productBtn.textContent;
      if (d.url) productBtn.href = d.url;
      thumbBtns.forEach(function (b, k) { b.setAttribute('aria-current', k === current ? 'true' : 'false'); });
      var tb = thumbBtns[current];
      thumbs.scrollTo({ left: tb.offsetLeft - thumbs.clientWidth / 2 + tb.clientWidth / 2, behavior: 'smooth' });
    }

    function open(items, start, opts) {
      if (!dlg) build();
      opts = opts || {};
      data = items; n = items.length; slides = []; thumbBtns = [];
      stage.querySelectorAll('.pk-pv__slide').forEach(function (s) { s.remove(); });
      thumbs.textContent = '';

      items.forEach(function (d, i) {
        var fig = document.createElement('figure');
        fig.className = 'pk-pv__slide';
        var img = document.createElement('img');
        img.alt = d.title || '';
        img.dataset.src = d.full;
        fig.appendChild(img);
        fig.addEventListener('click', function () { if (i !== current) show(i); });
        stage.appendChild(fig);
        slides.push(fig);

        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pk-pv__thumb';
        b.setAttribute('aria-label', 'Photo ' + (i + 1) + (d.title ? ': ' + d.title : ''));
        var t = document.createElement('img');
        t.src = d.thumb; t.alt = ''; t.loading = 'lazy';
        b.appendChild(t);
        b.addEventListener('click', function () { show(i); });
        thumbs.appendChild(b);
        thumbBtns.push(b);
      });
      arrows.forEach(function (a) { a.hidden = n < 2; });
      thumbs.hidden = n < 2;

      var productMain = opts.pvMain === 'product';
      productBtn.textContent = opts.pvProductLabel || '';
      productBtn.className = 'pk-pv__btn ' + (productMain ? 'pk-pv__btn--main' : 'pk-pv__btn--ghost');
      ctaBtn.textContent = opts.pvCtaLabel || '';
      ctaBtn.href = opts.pvCtaHref || '/pages/quote';
      ctaBtn.className = 'pk-pv__btn ' + (productMain ? 'pk-pv__btn--ghost' : 'pk-pv__btn--main');
      ctaBtn.hidden = !ctaBtn.textContent;
      // The filled button comes first.
      if (productMain) productBtn.parentNode.insertBefore(productBtn, ctaBtn);
      else ctaBtn.parentNode.insertBefore(ctaBtn, productBtn);
      dlg.setAttribute('aria-label', opts.pvTitle || 'Photos');
      dlg.classList.toggle('pk-pv--contain', opts.pvFit === 'contain');

      dlg.showModal();
      show(start || 0);
    }

    if (!supported) return;
    window.pkPhotoViewer = { open: open };

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-pk-gallery]');
      if (!trigger) return;
      var source = document.getElementById(trigger.dataset.pkGallery);
      if (!source) return;
      var items;
      try { items = JSON.parse(source.textContent); } catch (err) { return; }
      if (!items || !items.length) return;
      e.preventDefault();
      open(items, +trigger.dataset.pkGalleryStart || 0, source.dataset);
    });

    function reveal() {
      document.querySelectorAll('[data-pk-gallery][hidden]').forEach(function (el) { el.hidden = false; });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
    else reveal();
    // Theme editor: a re-rendered section brings its triggers back hidden.
    document.addEventListener('shopify:section:load', reveal);
  })();
  } catch(e) { console.error(e); }
})();

})();
